import React, { useCallback } from "react";

import { faBracketsCurly, faBug } from "@fortawesome/pro-regular-svg-icons";

import { CopyTextIcon } from "src/base-components/CopyTextIcon";
import { Icon } from "src/base-components/Icon";
import { SessionResponse } from "src/clients/agent-management";
import { usePowertools } from "src/powertools/hooks";
import { useWsInfo } from "src/powertools/useWsInfo";
import { getAgentLogsInsightsLink } from "src/powertools/utils";
import { useWorkspaceContext } from "src/router/routerContextHooks";

type SessionActionsProps = {
  sessionId: string | null;
  rawSessionData: SessionResponse | null;
};

export const SessionActions: React.FC<SessionActionsProps> = ({
  sessionId,
  rawSessionData,
}) => {
  const { workspace } = useWorkspaceContext();
  const wsInfo = useWsInfo(workspace);
  const isPowerToolsEnabled = usePowertools();

  const handleDebugLogs = useCallback(() => {
    if (wsInfo.data?.stack_name && wsInfo.data?.region && sessionId) {
      window.open(
        getAgentLogsInsightsLink(
          wsInfo.data.stack_name,
          wsInfo.data.region,
          sessionId,
        ),
        "_blank",
      );
    }
  }, [wsInfo.data?.stack_name, wsInfo.data?.region, sessionId]);

  return (
    <div className="flex items-center gap-2">
      {sessionId && (
        <CopyTextIcon
          dataLoc="copy-session-id-button"
          feedback="inline"
          size="xs"
          tooltip="Copy session ID"
          value={sessionId}
        />
      )}
      {isPowerToolsEnabled && rawSessionData && (
        <CopyTextIcon
          dataLoc="copy-raw-trace-json-button"
          feedback="inline"
          icon={faBracketsCurly}
          size="xs"
          tooltip="Copy raw trace JSON"
          value={() => JSON.stringify(rawSessionData, null, 2)}
        />
      )}
      {isPowerToolsEnabled && wsInfo.data && (
        <Icon
          color="text-gray-500 hover:text-gray-700"
          dataLoc="test-debug-logs-button"
          icon={faBug}
          size="sm"
          onClick={handleDebugLogs}
        />
      )}
    </div>
  );
};
